import React, {useEffect, useState} from 'react';
import {
    BrowserRouter as Router,
    Link
  } from "react-router-dom";
import { Text } from '../../containers/Language';
import { Link as ScrollLink } from 'react-scroll'
import logo from '../../logo.png';
import longLogo from './img/logo-long.png';
import calculatorSVG from "./img/calculator.svg"
import callSVG from "./img/call.svg"
import { useForm } from "react-hook-form";
import  LanguageSelector from '../LanguageSelector/LaguageSelector';

import {isMobile} from 'react-device-detect';

import classes from './Navigation.module.css';

function Navigation({onSetFromModal}) {

    const {reset } = useForm();
    const [fixed, setFixed] = useState(false);

    useEffect(() => {
        window.onscroll = () => {
            window.pageYOffset >= 300 ? setFixed(true) : setFixed(false)
        }
    }, [fixed])

    const handleClick = () => {
        reset({})
        onSetFromModal(false)
    }

  return (
    <>
        <div className={`${classes.Navigation} ${fixed && classes.Fixed}`}>
            <div className={`${classes.NavigationContainer} ${fixed && `${classes.FixedNavigationContainer} h-100`}`}>
                <nav className={`navbar navbar-expand-lg navbar-light ${classes.navbar} ${fixed && 'h-100'}`}>
                <div className={`container-fluid ${(fixed && !isMobile) && 'pe-0 h-100'}`}>
                
                    <Router>
                        <Link to={{ pathname: "/" }} className="navbar-brand">
                            <img className={(!fixed || isMobile)? classes.Logo : classes.longLogo} src={(!fixed || isMobile) ? logo : longLogo} alt='Logo' />
                        </Link>
                    </Router>
                    
                    <div className={`justify-content-end ${fixed && 'h-100'}`}>
                    <div className={`navbar-nav ${classes.navbar_nav} ${fixed && 'h-100'}`}>
                        <LanguageSelector />

                        <ScrollLink className={classes.nav_link} to="calculator" spy={true} duration={1000} >
                            <img src={calculatorSVG} alt='icon'/>
                            <span><Text tid="CALCULATOR" /></span>
                        </ScrollLink>

                        <Router>
                            <Link onClick={handleClick} to='/consultation' className={classes.nav_link} data-bs-toggle="modal" data-bs-target="#consultation">
                                <img src={callSVG} alt='icon'/><span><Text tid="CALL_ME" /></span>
                            </Link>
                        </Router>

                        <Router>
                            <Link to={{ pathname: "https://mylife.az/onlineapp" }} 
                                target="_blank">
                                <button className={`btn btn-primary btn-lg ${classes.apply} ${fixed && 'h-100 rounded-0'}`}><span><Text tid="APPLY" /></span></button>
                            </Link>
                        </Router>
                    </div>
                    </div>
                </div>
                </nav>
            </div>
        </div>
        {fixed && <div className={`${classes.overlay}`}></div>}
        
     </>

    
  );
}

export default Navigation;
